
import Main from './components/Main';
import ContextData from './context/ContextData'

function App() {
  return (

    <ContextData>

      
      <Main>

      </Main>
    </ContextData>

  );
}

export default App;
